import * as Icons from "lucide-react";

export function DynIcon({ name, ...props }) {
  const Ico = Icons[name] || Icons.Award;
  return <Ico {...props} />;
}

export const RARITY = {
  common: { label: "COMMON", ring: "#94A3B8", bg: "#F1F5F9" },
  rare: { label: "RARE", ring: "#3B82F6", bg: "#E5F0FF" },
  epic: { label: "EPIC", ring: "#8B5CF6", bg: "#F3E8FF" },
  legendary: { label: "LEGENDARY", ring: "#F59E0B", bg: "#FEF9C3" },
};

export function StatChip({ icon, value, label, color = "#662D91", testid }) {
  const Ico = Icons[icon] || Icons.Star;
  return (
    <div data-testid={testid} className="flex items-center gap-3 rounded-2xl bg-white px-4 py-3 shadow-sm border border-black/5">
      <div className="flex h-11 w-11 items-center justify-center rounded-xl" style={{ backgroundColor: color + "22" }}>
        <Ico size={22} color={color} />
      </div>
      <div className="leading-tight">
        <div className="font-head text-xl text-csh-blue">{value}</div>
        <div className="text-xs text-muted-foreground font-semibold uppercase tracking-wide">{label}</div>
      </div>
    </div>
  );
}

export function ProgressBar({ pct, className = "" }) {
  return (
    <div className={`h-4 w-full rounded-full bg-black/10 overflow-hidden ${className}`}>
      <div className="xp-bar h-full rounded-full transition-all duration-700" style={{ width: `${Math.max(0, Math.min(100, pct))}%` }} />
    </div>
  );
}

export function Loader({ label = "Loading your adventure..." }) {
  return (
    <div className="flex h-[60vh] flex-col items-center justify-center gap-4">
      <Icons.Loader2 className="animate-spin text-csh-purple" size={40} />
      <p className="font-head text-lg text-csh-blue">{label}</p>
    </div>
  );
}

export function EmptyState({ icon = "Sparkles", title, text }) {
  const Ico = Icons[icon] || Icons.Sparkles;
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-3xl border-2 border-dashed border-black/10 bg-white/60 py-14 text-center px-6">
      <Ico size={44} className="text-csh-orange" />
      <h3 className="font-head text-xl text-csh-blue">{title}</h3>
      {text && <p className="text-sm text-muted-foreground max-w-sm">{text}</p>}
    </div>
  );
}
